/**
 * 1:1 문의(QNA) — 목록·상세·답변(관리자)
 */
import api from './index.js'

/**
 * @param {{ page?: number, size?: number, keyword?: string, status?: string }} params
 */
export function getInquiryList(params) {
  return api.get('/api/v1/inquiries', { params })
}

export function getInquiryDetail(boardCode) {
  return api.get(`/api/v1/inquiries/${encodeURIComponent(boardCode)}`)
}

export function postInquiryReply(boardCode, text) {
  return api.post(`/api/v1/inquiries/${encodeURIComponent(boardCode)}/replies`, { text })
}

export function putInquiryAnswer(commentCode, text) {
  return api.put(`/api/v1/inquiries/comments/${encodeURIComponent(commentCode)}`, { text })
}

export function deleteInquiryAnswer(commentCode) {
  return api.delete(`/api/v1/inquiries/comments/${encodeURIComponent(commentCode)}`)
}
